import { singleton } from "tsyringe";

@singleton()
export class Browser {
  private recognizeChromiumBuild(browserVersion, userAgent) {
    const temp: RegExpMatchArray = userAgent.match(/\b(OPR|Edg)\/(\d+)/);
    if (temp !== null) {
      return temp
        .slice(1)
        .join(" ")
        .replace("OPR", "Opera")
        .replace("Edg", "Edge");
    } else {
      return "Chrome " + browserVersion; // CriOS is Chrome on iOS
    }
  }

  private recognizeIEBuild(userAgent) {
    const temp: RegExpMatchArray = /\brv[ :]+(\d+)/g.exec(userAgent) || [""];
    return `IE ${temp[1] || ""}`;
  }

  private getBrowserNameAndVersion(userAgent) {
    const [, browserName, browserVersion] =
      userAgent.match(
        /(opera|chrome|safari|firefox|msie|trident|CriOS(?=\/))\/?\s*(\d+)/i,
      ) || [];
    return [browserName, browserVersion];
  }

  private recognizeDefaultBrowser(
    userAgent,
    appName,
    appVersion,
    browserName,
    browserVersion,
  ) {
    const browserData = browserVersion
      ? [browserName, browserVersion]
      : [appName, appVersion, "-?"];
    const temp: RegExpMatchArray = userAgent.match(/version\/(\d+)/i);
    if (temp !== null) {
      browserData.splice(1, 1, temp[1]);
    }
    return browserData.join(" ");
  }

  public getBrowser(): string {
    const { appName, appVersion, userAgent } = window.navigator;
    const [browserName, browserVersion] =
      this.getBrowserNameAndVersion(userAgent);

    if (/trident/i.test(browserName)) {
      // Trident is the IE engine
      return this.recognizeIEBuild(userAgent);
    }

    if (browserName === "Chrome" || browserName === "CriOS") {
      // CriOS is Chrome on iOS
      return this.recognizeChromiumBuild(browserVersion, userAgent);
    }

    return this.recognizeDefaultBrowser(
      userAgent,
      appName,
      appVersion,
      browserName,
      browserVersion,
    );
  }
}
